import { Selector } from 'react-redux';
import type { RootState } from '../index';
import { Toastr } from './reducer';

export const getToastrToShow: Selector<RootState, Toastr | undefined> = (state) =>
    state.toastr.data[state.toastr.data.length - 1];
